"use client";
import React, { useState } from "react";
import { cx } from "class-variance-authority";
import Image from "next/image";
import CodeSnippet from "./CodeSnippet";
import { AIML, CrossBridge, DApps, DEFI, DEX, ERC4337, ERC6551, ERC7702, JSONRPC, NFT, SHA256, Solana, SPHINICS, SWAP, UserOps, WalletDevelopment} from "./codeSnippets";

export const dynamic = "force-dynamic";

const DigitalProductDevelopment = () => {
  const [Active, setActive] = useState(1);

  const Warehousing = (id) => {
    setActive(id);
  };

  const buttonCommonCss = "ease-in-out duration-700 shadow shadow-[#00000040] font-normal text-sm lg:text-base px-4 md:px-5 py-2 rounded-full mr-3 md:my-2 my-1 font-manrope no-underline";
  const inActiveColor = `bg-white hover:bg-[#410EAD] text-[#410EAD] hover:text-white border hover:border-[#410EAD] ${buttonCommonCss}`;
  const activeColor = `bg-[#410EAD] border-[#410EAD] text-white ${buttonCommonCss}`;

  const buttonData = [
    { id: 1, name: "NFT" },
    { id: 2, name: "DEFI" },
    { id: 3, name: "Wallet Development" },
    { id: 4, name: "User Ops" },
    { id: 5, name: "DApps" },
    { id: 6, name: "Solana" },
    { id: 7, name: "ERC 4337" },
    { id: 8, name: "ERC 6551" },
    { id: 9, name: "ERC 7702" },
    { id: 10, name: "JSON-RPC" },
    { id: 11, name: "SWAP" },
    { id: 12, name: "Cross-Bridge" },
    { id: 13, name: "AI/ML" },
    { id: 14, name: "DEX" },
    { id: 15, name: "SPHINICS+" },
    { id: 16, name: "SHA-256" },
  ];

  return (
    <>
      <section className="my-20 ">
        <h4 className="text-2xl sm:text-3xl xl:text-4xl md:leading-[52px] leading-8 font-bold font-manrope text-center container mx-auto px-1.5 sm:px-4 md:px-24 lg:px-24 xl:px-40">
          Lead in blockchain innovation by never giving up as you
          deliver groundbreaking digital services with us.
        </h4>

        <div className="my-16 lg:my-[100px]">
          <div className="flex justify-center">
            <Image
              src="/assets/General-Img/Home/Lead-in-blockchain.gif"
              alt="Lead in Blockchain"
              width={300}
              height={300}
              className="w-full max-w-[900px] h-auto"
            />
          </div>
        </div>

        <div className="container mx-auto sm:px-4 px-1 md:px-24 lg:px-24 xl:px-0 z-50">
          <div className="grid lg:grid-cols-2 gap-2">
            <div className="container my-auto">
              <h2 className="text-2xl sm:text-3xl xl:text-4xl font-bold pb-4 text-center lg:text-start font-manrope">
                Get started with{" "}
                <span className="text-[#410EAD] font-manrope">
                  Tanθ
                </span>
              </h2>
              <p className="text-[#59587C] text-sm lg:text-lg text-center lg:text-start md:px-14 lg:px-0 xl:pr-60 pb-2">
                Our award and recognitions validate that when businesses think about expanding into mobile segment, we are the top Web3 and blockchain app development company in US they turn to.
              </p>
              <div className="flex flex-wrap justify-center lg:justify-start xl:pr-60">
                {buttonData?.map((button, ind) => (
                  <button
                    key={button?.id || ind}
                    className={cx(
                      Active === button?.id
                        ? activeColor
                        : inActiveColor
                    )}
                    onClick={() => {
                      Warehousing(button?.id);
                    }}
                  >
                    {button?.name}
                  </button>
                ))}
              </div>
            </div>

            <div className="container mx-auto lg:mt-0">
              <div className="border border-[#D7D7D7] rounded-[20px] p-0 lg:p-4">
                {Active === 1 && <CodeSnippet fullCode={NFT} />}
                {Active === 2 && <CodeSnippet fullCode={DEFI} />}
                {Active === 3 && <CodeSnippet fullCode={WalletDevelopment} />}
                {Active === 4 && <CodeSnippet fullCode={UserOps} />}
                {Active === 5 && <CodeSnippet fullCode={DApps} />}
                {Active === 6 && <CodeSnippet fullCode={Solana} />}
                {Active === 7 && <CodeSnippet fullCode={ERC4337} />}
                {Active === 8 && <CodeSnippet fullCode={ERC6551} />}
                {Active === 9 && <CodeSnippet fullCode={ERC7702} />}
                {Active === 10 && <CodeSnippet fullCode={JSONRPC} />}
                {Active === 11 && <CodeSnippet fullCode={SWAP} />}
                {Active === 12 && <CodeSnippet fullCode={CrossBridge} />}
                {Active === 13 && <CodeSnippet fullCode={AIML} />}
                {Active === 14 && <CodeSnippet fullCode={DEX} />}
                {Active === 15 && <CodeSnippet fullCode={SPHINICS} />}
                {Active === 16 && <CodeSnippet fullCode={SHA256} />}
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default DigitalProductDevelopment;
